import propertyTypeDropdown from "../components/propertyTypeDropdown";
import dom from "../../../common/ts/core/dom";
import homeSearchBoxForm from "../components/homeSearchBoxForm";

dom.init();
propertyTypeDropdown.init();
homeSearchBoxForm.init();
